import {
    IBridgeMessage,
    IConcordiumWalletQrModalOptions,
    TypedEventEmitter,
} from '@pioneeringtechventures/concordium-wallet-client';
import type { IConcordiumQRCodeModal } from '@tacans/shared-marketplace-layer';
import dynamic from 'next/dynamic';
import React from 'react';
import ReactDOM from 'react-dom';
import AppThemeProvider from 'src/features/common/app/components/theme-provider';

const ConcordiumQrModal = dynamic(() => import('src/features/common/wallet/components/concordium-qr-modal'), {
    ssr: false,
});

export class ConcordiumQrModalAdapter implements IConcordiumQRCodeModal {
    private readonly pubSub = TypedEventEmitter;

    private wrapperElement: HTMLDivElement | null = null;

    private get wrapper(): HTMLDivElement {
        if (this.wrapperElement) return this.wrapperElement;
        this.wrapperElement = document.createElement('div');
        this.wrapperElement.setAttribute('id', 'concordium-wallet-qr');
        document.body.appendChild(this.wrapperElement);
        return this.wrapperElement;
    }

    constructor(opts: IConcordiumWalletQrModalOptions) {
        this.pubSub.on('close', () => {
            this.close();
            opts.onClose();
        });
    }

    public close(): void {
        if (this.wrapperElement) {
            document.body.removeChild(this.wrapperElement);
            this.wrapperElement = null;
        }
    }

    public open(msg: IBridgeMessage): void {
        ReactDOM.render(
            <AppThemeProvider theme="dark">
                {/* @ts-ignore */}
                <ConcordiumQrModal uri={msg.connect_string!} onClose={() => this.pubSub.emit('close')} />
            </AppThemeProvider>,
            this.wrapper
        );
    }
}